export type PluralCategory = 'one' | 'few' | 'many' | 'other';

/** Plural forms of one message. English uses one/other; Polish one/few/many (+ other for fractions). */
export type PluralForms = {
  readonly one: string;
  readonly few?: string;
  readonly many?: string;
  readonly other: string;
};

/**
 * Plural category without Intl.PluralRules (incomplete on some Hermes builds).
 * Polish: 1 transakcja, 2–4 transakcje, 5–21 transakcji, 22–24 transakcje, 12–14 transakcji.
 */
export function pluralCategory(language: 'pl' | 'en', count: number): PluralCategory {
  if (language === 'en') return count === 1 ? 'one' : 'other';
  if (!Number.isInteger(count)) return 'other';
  const n = Math.abs(count);
  if (n === 1) return 'one';
  const lastDigit = n % 10;
  const lastTwo = n % 100;
  if (lastDigit >= 2 && lastDigit <= 4 && !(lastTwo >= 12 && lastTwo <= 14)) return 'few';
  return 'many';
}

export function selectPlural(forms: PluralForms, category: PluralCategory): string {
  return forms[category] ?? forms.other;
}
